"use client"

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useStore } from '@/lib/store'

/**
 * While kiosk mode is on, every main-app route bounces to /kiosk. The kiosk
 * device stays fully logged in (RLS needs the session), so this store-level
 * lock — not the URL — is what keeps a customer out of the owner's data:
 * escaping fullscreen or typing /accounting just lands back on the kiosk.
 * Turned off only by the admin PIN on the kiosk's exit dialog.
 */
export function KioskGuard() {
  const kioskMode = useStore((s) => s.kioskMode)
  const router = useRouter()

  useEffect(() => {
    if (kioskMode) router.replace('/kiosk')
  }, [kioskMode, router])

  return null
}
